// @flow
import React from "react";
import LineItemTableSubSection from "../LineItemTableSubSection/LineItemTableSubSection";
import s from "../LineItemTable/LineItemTable.less";

type Props = {
  data: Object,
  tableTitle: string,
  totalFob: number,
  totalCost?: number
};

const LineItemTable = (props: Props) => (
  <div className={`${s.lineItemTable}`}>
    {Object.keys(props.data).map(section => {
      return (
        <LineItemTableSubSection
          sortBy={props.sortBy}
          totalFob={props.totalFob}
          isNby={props.isNby}
          key={section}
          section={section}
          data={props.data[section]}
          tableTitle={props.tableTitle}
          totalCost={props.totalCost}
        />
      );
    })}
  </div>
);

export default LineItemTable;



// WEBPACK FOOTER //
// ./src/components/CBDTables/LineItemTables/LineItemTablesContainer/LineItemTable/LineItemTable.js